import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';
import InnerPage from './TruVoiceFieldsInnerPage';
class TruVoiceFieldsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { location: { pathname } } = this.props;

    const comps = [
      {
        uri: 'opportunities',
        source: 'opportunity',
        label: 'Opportunity Based',
      },
      {
        uri: 'accounts',
        source: 'account',
        label: 'Account Based',
      },
    ];


    return (
      <div className="container">
        <Helmet title="TruVoice Field Mappings" />
        <div>
          {comps.length > 1 &&
            <div>
              <ul className="nav nav-tabs">
                {comps.map(comp => (
                  <LinkContainer key={comp.uri} to={`/setup/truvoice-fields/${comp.uri}`}>
                    <NavItem>{comp.label}</NavItem>
                  </LinkContainer>
                ))}
              </ul>
              <p />
            </div>
          }
          {comps.length > 0 && pathname === '/setup/truvoice-fields' && <Redirect to={`/setup/truvoice-fields/${comps[0].uri}`} />}
        </div>
        <div>
          <Switch>
            {comps.map((comp) => {
              return (
                <Route
                  key={comp.uri}
                  path={`/setup/truvoice-fields/${comp.uri}`}
                  render={(props) => {
                    return (<InnerPage source={comp.source} {...props} />);
                  }}
                />
              );
            })}
          </Switch>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

TruVoiceFieldsPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
};

TruVoiceFieldsPage.contextTypes = {
  router: PropTypes.shape({}),
};

export default withRouter(connect(mapStateToProps)(TruVoiceFieldsPage));
